module.exports = __webpack_public_path__ + "img/termnconditon.4dc83aa8.png";